import { Eye, EyeOff } from "lucide-react";

// Visibility options for node labels
export type VisibilityOption = "hidden" | "visible";

interface LabelWithVisibilityToggleProps {
  label: string;
  visibility: VisibilityOption;
  onToggleVisibility: () => void;
  className?: string;
  labelClassName?: string;
}

/**
 * A reusable component that combines a label with a visibility toggle
 * The visibility toggle appears on the right side of the label
 */
export default function LabelWithVisibilityToggle({
  label,
  visibility,
  onToggleVisibility,
  className = "",
  labelClassName = "",
}: LabelWithVisibilityToggleProps) {
  const isHidden = visibility === "hidden";
  
  return (
    <div className={`flex justify-between items-center ${className}`}>
      <label className={`block text-xs font-medium text-gray-700 dark:text-gray-300 ${labelClassName}`}>
        {label}
      </label>
      <button
        type="button"
        onClick={onToggleVisibility}
        className={`ml-2 p-1 rounded transition-colors ${
          isHidden 
            ? "bg-red-100 dark:bg-red-900/30 text-red-600 hover:bg-red-200 dark:text-red-400 dark:hover:bg-red-900/40" 
            : "text-gray-500 hover:bg-gray-200 dark:text-gray-400 dark:hover:bg-gray-600"
        }`}
        title={isHidden ? "Show label" : "Hide label"}
      >
        {isHidden ? (
          <EyeOff className="h-4 w-4" />
        ) : (
          <Eye className="h-4 w-4" />
        )}
      </button>
    </div>
  );
}
